import request from '@/utils/request'
import dayjs from 'dayjs'

// 获取过磅列表
export function getList(params) {
  const { page: current, limit: size, ...otherWhere } = params
  const { date, ...data } = otherWhere
  const wherePrefix = 'eq_owd.'
  const payload = {
    page: { current, size },
    where: {
      "desc_owd.createTime": '1',
      "ge_owd.createTime": date[0] ? dayjs(date[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss') : undefined,
      "le_owd.createTime": date[1] ? dayjs(date[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss') : undefined,
      ...Object.assign({}, ...Object.keys(data).map((key) => ({ [wherePrefix + key]: data[key] || undefined })))
    }
  }
  return request.post('/owdr/getPage', payload)
}

// 更新过磅信息
export function updateOne(data) {
  return request.post('/owdr/updateRecordById', data)
}
